module.exports = __webpack_public_path__ + "img/20200614_112117.118e8fff.jpg";